import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/unix-timestamp-calculator',
  component: () => import('../../routes/UnixTimestampCalculator.svelte'),
  card: {
    id: 'unix-timestamp-calculator',
    title: 'Unix Timestamp Calculator',
    description: 'Convert between Unix timestamps, epoch seconds/milliseconds, and human-readable dates.',
    icon: 'schedule',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/unix-timestamp-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Unix Timestamp Calculator – Epoch Converter',
    description: 'Convert Unix timestamps to human-readable dates and vice versa. Supports epoch seconds, milliseconds, and standard date formats.',
  },
};

export default meta;